import { Event } from '../../../base/common/event.js';
import '../../../base/common/iterator.js';
import '../../../base/common/lifecycle.js';
class NullPolicyService {
    constructor() {
        this.onDidChange = Event.None;
    }
    async updatePolicyDefinitions() { return {}; }
    getPolicyValue() { return undefined; }
    serialize() { return undefined; }
}
export { NullPolicyService };
